import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";

@Injectable()
export class PrintService {

    // debounce
    static printing = false;

    /**
     * @param {Node} printContent: the DOM Node to print
     * @description Prints the given DOM Node. The css class hide-on-print can be
     *              applied to elements that should be hidden when printing.
     *              A wrench logo is automatically applied as a header.
     *              TODO: This doesn't work in the user app :(
     */
    static print(printContent: Node) {
        if (this.printing || environment.app) {
            return;
        }
        this.printing = true;

        printContent = printContent.cloneNode(true);

        // Open a new window
        const printWindow = window.open('', 'Wrench', 'toolbar=0,status=0');

        const baseTag = document.createElement('base');
        baseTag.setAttribute('href', window.location.origin);
        printWindow.document.head.appendChild(baseTag);

        // Get all the styles on the page
        const styles = document.querySelectorAll('style, link[rel=stylesheet]');

        // Write copies of the styles to the head of the new document
        styles.forEach((styleElt: HTMLStyleElement) => {
            printWindow.document.head.appendChild(styleElt.cloneNode(true));
        });

        // write the header image
        const headerImg = document.createElement('img');
        headerImg.style.width = '200px';
        headerImg.style.margin = 'auto';
        headerImg.style.display = 'block';

        printWindow.document.body.appendChild(headerImg);

        // TODO: Is there a better way to wait for the content to load?
        //       all the load events I have tried don't work because the
        //       document has already loaded. This at least ensures that the
        //       header image asset will be loaded. The setTimeout is so the DOM
        //       can be painted before opening the print dialog.
        headerImg.onload = () => {
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
                this.printing = false;
            }, 1000);
        };
        headerImg.onerror = headerImg.onload;

        // Write the copy of the elements we want to the body of the new document
        printWindow.document.body.appendChild(printContent);

        headerImg.src = $localize`https://wrench.com/images/main-logo-horizontal.png`;

        // hide 'hide-on-print' elements
        const eltsToHide = printWindow.document.body.querySelectorAll('.hide-on-print');
        eltsToHide.forEach((elt: Element) => elt.remove());

        printWindow.focus();
    } // print

}
